module.exports = __webpack_public_path__ + "static/media/user-phone-poco.b11a33bf.svg";